module.exports = __webpack_public_path__ + "img/1505912573.d853fa11.jpg";